window.SubscriptionCartPolicy = {

  hasSubscription(cart) {
    return cart.items.some(item => {
      const title = item.variant_title?.toLowerCase() || '';

      return (
        title.includes('mensal') ||
        title.includes('2 meses') ||
        title.includes('3 meses')
      );
    });
  },

  isOneTimeProduct(productTitle = '') {
    return productTitle.toLowerCase().includes('única');
  },

  showMixedCartAlert() {
    document.dispatchEvent(
      new CustomEvent('openSubscriptionAlert', {
        detail: {
          title: 'Sua assinatura já está ativa',
          description:
            'Produtos avulsos e assinaturas precisam ser comprados separadamente.'
        }
      })
    );
  },

  validate({ cart, productTitle }) {

    const hasSubscription =
      this.hasSubscription(cart);

    const isOneTime =
      this.isOneTimeProduct(productTitle);

    if (hasSubscription && isOneTime) {

      this.showMixedCartAlert();

      return false;
    }

    return true;
  }
};